import React, { useMemo } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { IProductInsideCombo } from 'src/types/combo';
import { IProduct, PRODUCT_TYPE } from 'src/types/products';
import { formatPrice, getTranslate } from 'src/utils/formatter';
import { filterDefiniteSizeSelectedItems, isUnavailableComboItem } from 'src/utils/helpers';

interface IProps {
  product: IProduct;
}

const CartProductItems: React.FC<IProps> = (props: IProps): JSX.Element | null => {
  const items = useMemo((): IProductInsideCombo[] => {
    if (props.product.type === PRODUCT_TYPE.MEAL_COMBO) {
      return filterDefiniteSizeSelectedItems(props.product.items || [], props.product.size);
    }

    // deal combo items
    return props.product.items || [];
  }, [props.product.type, props.product.items, props.product.size]);

  const itemClassName = (item: IProductInsideCombo): string => {
    let className: string = 'family-semibold text-size-16 text-md-size-14 color-darkgray mr-2';
    if (item.error || isUnavailableComboItem(item)) className += ' invalid text-through';
    return className;
  };

  if (!items.length) return null;

  return (
    <div className="d-flex flex-column">
      <p className="color-gray text-uppercase text-size-12 text-md-size-8 mb-2 family-regular">
        {localeStore.t('combo_products')}
      </p>
      {items.map((item) => (
        <div className="d-flex flex-row align-items-center mb-2">
          <p key={item.id} className={itemClassName(item)}>
            {getTranslate(item.name)}
          </p>
          {props.product.type === PRODUCT_TYPE.MEAL_COMBO ? (
            <p className="family-regular text-md-size-10 text-size-14 color-gray d-flex text-nowrap option-price">
              {<span className="d-flex d-md-none">+</span>} {formatPrice(Number(item.price))}
            </p>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default React.memo(CartProductItems);
